export default {
  // 标题
  input: "输入",

  // 按钮
  collapseAll: "收起全部",
  viewAll: "查看全部",

  // 消息提示
  copySuccess: "复制成功",
};
